import React from 'react';
import { ConfirmDialog } from './dialogKit';

// Older pages (VPN servers, server IPs, connect logs) call this; it is the shared ConfirmDialog
const DeleteConfirmationDialog = ({ open, handleClose, handleDelete, itemName, title = 'Delete item?', message }) => {
  const handleConfirmDelete = () => {
    handleDelete();
    handleClose();
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleClose}
      onConfirm={handleConfirmDelete}
      title={title}
      message={message || 'The selected item is removed for every user.'}
      item={itemName}
    />
  );
};

export default DeleteConfirmationDialog;
